export enum SuccessMessageKeysEnum {
  FEEDBACK_SENT = 'leaveFeedbackPopup.feedbackSentSuccessfully',
  CONFIRM_APPOINTMENT_SENT = 'bookingPage.confirmAppointmentPage.sentSuccessfully',
  LOGIN = 'bookingPage.confirmAppointmentPage.authSection.sentSuccessfully',
}
